// extracted by mini-css-extract-plugin
module.exports = {"Root":"TinyField_Root__2d5TH","CloseIcon":"TinyField_CloseIcon__36UQ6","OverFlowText":"TinyField_OverFlowText__3uik1"};